import selectors from '../../../rootSelectors';
import { DAZE_INSTRUCTIONS } from '../../dazeConstants';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import {
    highlightDownButton, blockScreen, greyOutScreen, unblockScreen,
    greyOutOkButton, colorInOkButton,
} from '../../../common/screen/screenActions';
import { setIsReadyScriptPlayed, highlightDazeResponses }
    from '../../dazeActions';
import { SCROLL } from '../../../constants/assessmentItemType';
import { goToCountdown } from '../../../common/navigation/navigationActions';
import { DAZE } from '../../../constants/measure';

const SCROLL_INSTRUCTIONS = DAZE_INSTRUCTIONS[SCROLL];

export const narrateReadyScript = () => (dispatch) => dispatch(playAvatarAudio([SCROLL_INSTRUCTIONS.scrollIntroInstruction,
    SCROLL_INSTRUCTIONS.scrollDownInstruction]))
    .then(() => {
        dispatch(highlightDownButton());
    });

export const onNextButtonClick = () => (dispatch, getState) => {
    const state = getState();
    if (selectors.getDazeReadyForNextScript(state)) {
        return dispatch(goToCountdown(DAZE));
    }
    dispatch(blockScreen());
    dispatch(greyOutScreen());
    dispatch(greyOutOkButton());
    return dispatch(playAvatarAudio([SCROLL_INSTRUCTIONS.scrollReadyInstruction,
        SCROLL_INSTRUCTIONS.scrollReadyClickOk]))
        .then(() => {
            dispatch(setAvatarInstructions([SCROLL_INSTRUCTIONS.scrollReadyInstruction,
                SCROLL_INSTRUCTIONS.scrollReadyClickOk]));
            dispatch(setIsReadyScriptPlayed(true));
            dispatch(unblockScreen());
            dispatch(colorInOkButton());
        });
};

export const highlightCorrectResponses = () => (dispatch, getState) => {
    const state = getState();
    const questions = selectors.getDazeQuestionItems(state, SCROLL);
    const responses = questions.reduce((result, item) => {
        const response = result;
        response[item.id] = item.correctResponse;
        return response;
    }, {});
    return dispatch(highlightDazeResponses(responses));
};
